import { render } from "./StatsSkeleton.vue?vue&type=template&id=51b81ddc"
import script from "./StatsSkeleton.vue?vue&type=script&lang=js"
export * from "./StatsSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__